import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

const BASE_API_URL = '';

@Injectable({
  providedIn: 'root'
})
export class UpdatePaymentService {
  constructor(private http: HttpClient) {

  }

  transformTdsPendingPayments(result) {
    result.dataList.forEach(element => {
      element.display_text = element.amount+" ,"+element.paymentdate+" ,"+element.referenceno;
    });
    return result;
  }

  getTdsPendingPayments(custId:any): Observable<any> {
    const get_url = BASE_API_URL + 'subscriber/getTdsPendingPayments/'+custId;
    return this.http.get<any>(get_url,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return this.transformTdsPendingPayments(res);
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }


  updatePayment(payment_data:any,paymentId:any): Observable<any> {
    const get_url = BASE_API_URL + 'subscriber/updatePayment/'+paymentId;
    return this.http.post<any>(get_url,payment_data,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }



}
